import React from 'react';
import { useStore } from '@/context/StoreContext';
import { Seo } from '@/components/Seo';
import credits from '@/lib/imageCredits.json';
import { ExternalLink } from 'lucide-react';

export default function Credits() {
  const { t, lang } = useStore();
  return (
    <div className="bg-nw-black">
      <Seo title={t.credits.title} description={t.credits.intro} path="/credits" lang={lang} noindex />
      <div className="relative py-16 border-b border-nw-gold/12">
        <div className="nw-container text-center">
          <div className="nw-eyebrow mb-3">NICEWINE</div>
          <h1 data-testid="credits-title" className="font-serif text-4xl sm:text-5xl text-nw-ivory">{t.credits.title}</h1>
          <p className="mt-4 max-w-2xl mx-auto text-nw-warmgrey text-sm leading-relaxed">{t.credits.intro}</p>
        </div>
      </div>
      <div className="nw-container py-12 lg:py-16">
        <ul data-testid="credits-list" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {credits.map((c) => (
            <li key={c.title} className="border border-nw-gold/15 bg-nw-espresso/40 p-5 text-sm">
              <div className="font-serif text-nw-ivory text-base leading-snug">{c.title.replace(/\.[a-z]+$/i, '')}</div>
              <div className="mt-2 text-nw-warmgrey text-xs leading-relaxed">
                <div><span className="text-nw-gold/80">{lang === 'fr' ? 'Auteur' : 'Author'} :</span> {c.artist}</div>
                <div><span className="text-nw-gold/80">{t.credits.licence} :</span> {c.license_url ? <a href={c.license_url} target="_blank" rel="noreferrer" className="nw-link underline-offset-2 hover:underline">{c.license}</a> : c.license}</div>
                <div><span className="text-nw-gold/80">{t.credits.usedFor} :</span> {c.used_for}</div>
              </div>
              {c.source && (
                <a href={c.source} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1 text-[11px] tracking-luxe uppercase text-nw-gold hover:text-nw-ivory transition-colors">
                  {t.credits.source} <ExternalLink size={11} />
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
